import React from 'react'
import { Link } from 'react-router-dom';
import './Enseignant.css' ;
import Image from "../../asserts/images/e.png" ;
function page1() {
  return (
    <div class="contentimagesEnseignats">
            <Link to="/Lazhar hamel" className='linkliste' >
                <div className="carteEnseignant">
                    <div className='imgcardEnseignant'>
                        <img src={Image}></img>
                    </div>
                    <div className='descr'> 
                        <p className='email1'>Lazhar Hamel</p>
                        <p ><i class="fa-regular fa-envelope"></i> mailto:lazhar.hamel@gmail.com</p>
                    </div>
                    
                </div>
            </Link>
            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Abdesalem Ben Abdelali</p> 
                    <p ><i class="fa-regular fa-envelope"></i> mailto:abdelalienis@yahoo.fr</p>
                </div>
            </div>
                     
            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Nejib Ben Nasr</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> mailto:bennasrnejib@yahoo.fr</p>
                </div>
            </div>

            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Halim Sghaier</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> mailto:Halim.Sghaier@isimm.rnu.tn</p>
                </div>
            </div>

            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Mohamed Eloued</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> mailto:wadyel@yahoo.fr</p>
                </div>
            </div>

            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Sadok Bazine</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> mailto:sbazine.ens@gmail.com</p>
                </div>
            </div>

            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Fares Tounsi</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> mailto:tou_fares@yahoo.fr</p>
                </div>
            </div>

            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Mohamed Kassab</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> mailto:mohamed.kassab@gmail.com</p>
                </div>
            </div>
            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Mourad Kmimech</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> mailto:mkmimech@gmail.com</p>
                </div>
            </div>
            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Skander Douss</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> skandar.douss@gmail.com</p>
                </div>
            </div>

            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Nejib Hassen</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> mailto:nejib.hassen@fsm.rnu.tn</p>
                </div>
            </div>
            <div className="carteEnseignant">
                <div className='imgcardEnseignant'>
                    <img src={Image}></img>
                </div>
                <div className='descr'> 
                    <p>Faouzi Trabelsi</p>
                    <p className='email1'><i class="fa-regular fa-envelope"></i> mailto:Trabelsi_faouzi@yahoo.fr</p>
                </div>
            </div>
            
            
    
        </div> 
        
        )
}

export default page1